
import { initialState, rolesPredefinidos } from './common';
export default {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setNewContractDataCustomer(state, payload) {
    state.newContractData.customer = payload;
  },
  setNewContractDataProduct(state, payload) {
    state.newContractData.product = payload;
  },
  setNewPromotionData(state, payload) {
    state.newPromotionData = payload;
  },
  setNewPromotionCustomerData(state, payload) {
    state.newPromotionData.customers.legal_identifier = payload;
  },
  setNewRecoveryData(state, payload) {
    state.recoveryData = payload;
  },
  setContractInfo(state, payload) {
    state.contractInfo = payload;
  },
  setViewResponsive(state, payload) {
    state.responsive = payload;
  },
  setRoles(state, roles) {
    let rolesTemp = {};
    if (Array.isArray(roles) && roles.length > 0){
      rolesPredefinidos.forEach((rol) => {
        if (roles.includes(rol)) {
          rolesTemp[rol] = true;
        }else {
          rolesTemp[rol] = false;
        }
      });
    }
    state.roles = rolesTemp;
  },
  RESET_STATE(state) {
    Object.assign(state, initialState);
  },
  RESET_STATE_PROMOTIONS(state) {
    Object.assign(state.newPromotionData, initialState.newPromotionData);
    Object.assign(state.recoveryData, initialState.recoveryData);
  },
  RESET_STATE_CONTRACTS(state) {
    Object.assign(state.newContractData, initialState.newContractData);
  },
};
